<template>
    <div>
      <!-- 头部 -->
      <Header title="sheshou"></Header>
      <Banner :bgImg="bannerImg" :title="'sheshou'"></Banner>
      <div class="tianqBox">
        <!-- 引擎 -->
        <div class="indexYq bannerW">
           <div class="yqBox wow slideInUp">
             <div :class="['left',lang=='en'?'wd448':'wd372']" >
               <p :class="['yqName',lang=='en'?'wd448 font40':'wd372 font50']">{{$t('sheshou.summary.tit1')}}</p>
               <p class="yqDscp">{{$t('sheshou.summary.tips1[0]')}}</p>
             </div>
             <div class="right">
               <img src="@/assets/images/sheshou1.png" alt="">
             </div>
           </div>
           <div class="yqBox wow slideInUp">
             <div class="right">
               <img src="@/assets/images/sheshou2.png" alt="">
             </div>
             <div :class="['left',lang=='en'?'wd448':'wd372']" >
               <p :class="['yqName',lang=='en'?'wd448 font40':'wd372 font50']">{{$t('sheshou.summary.tit2')}}</p>
               <p class="yqDscp">{{$t('sheshou.summary.tips2[0]')}}</p>
             </div>
           </div>
         </div>
         <!-- 样式 -->
         <div class="style bannerW wow slideInUp">
             <div class="styleText">
                <p :class="{'title':true,'en':lang=='en'}">{{$t('sheshou.summary.tit3')}}</p>
               <!-- <p>样式灵活<br>入口丰富</p> -->
               <div class="bankuai">
                    <ul>
                        <li v-for="(key,index) in $t('sheshou.summary.tips3')" :key="index" :class="index==tabIndex?'active':''" @click="tabChange(index)">{{key.name }}</li>
                    </ul>
               </div>
             </div>
             <div class="styleTemp">
              <img :src="tqTempList[tabIndex]" alt="">
             </div>
         </div>
     </div>
       <!-- 介绍：一站式介入 -->
       <div class="tqDesc">
            <div class="bannerW">
              <ul>
                <li v-for="(key,index) in $t('tianqin.desc')" :key = "index">
                  <div class="imgDesc">
                    <img :src="tqDescImg[index]" alt="">
                  </div>
                  <div class="imgText">
                    <p :class="'name name'+index">{{key.n}}</p>
                    <p :class="'desc desc'+index">{{key.d}}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
      <!-- 尾部 -->
      <Footer></Footer>
    </div>
  </template>
  
  <script>
    import Header from "../../components/header.vue";
    import Footer from "../../components/footer.vue";
    import silder1 from "@/assets/images/slider.png";
    import Banner from "../../components/banner.vue";
    import bannerImg from  "@/assets/images/bg2.png"
    import prj1 from "@/assets/images/arrow-w@2x.png";
    import b1 from "@/assets/images/b1.png";
    import b2 from "@/assets/images/b2.png";
    import b3 from "@/assets/images/b3.png";
    import b4 from "@/assets/images/b4.png";
    import temp1 from "@/assets/images/ssTemp.png";
    import temp2 from "@/assets/images/dbxf.png";
    import temp3 from "@/assets/images/kp.png";
    import temp4 from "@/assets/images/gdkm.png";
    import temp5 from "@/assets/images/xxlm.png";
    import temp6 from "@/assets/images/tc.png";

    export default {
      name: "sheshou",
      components: {
        Header,
        Footer,
        Banner,
      },
      data(){
        return{
          tqDescImg:[b1,b2,b3,b4],
          bannerImg:bannerImg,
          projectList:[{
            projectName:"天琴",
            projectType:"/H5广告平台",
            img:prj1,
          },{
            projectName:"天琴",
            projectType:"PC/H5广告平台",
            img:prj1,
          },{
            projectName:"天琴",
            projectType:"PC/H5广告平台",
            img:prj1,
          }],
          listImg:[
            {
              adr:"javascript:;",
              image:silder1
            },
            {
              adr:"javascript:;",
              image:silder1
            },
            {
              adr:"javascript:;",
              image:silder1
            }
          ],
          tabIndex:0,
          tqTempList:[temp1,temp2,temp3,temp4,temp5,temp6],
          lang: this.$i18n.locale
        }
      },
      methods: {
        tabChange(index){
          this.tabIndex = index;
        }
      }
    };
  </script>
  <style lang="scss" scoped>
    /* @import url("../assets/css/common.scss"); */
    @import url("https://fonts.googleapis.com/css?family=Work+Sans:400,700,900");
    $anim-text-offset: 1em;
    .style{
      display: flex;
      flex-direction: row;
      justify-content:space-between;
      padding-left: 98px;
      padding-bottom: 117px;
      margin-top: 168px;
      box-sizing: border-box;
      padding-right: 100px;
      .styleText{
          margin-top: 86px;
        .title{
            width:100%;
            height:84px;
            font-size:60px;
            font-family:Microsoft YaHei;
            font-weight:600;
            color:rgba(34,34,34,1);
            line-height:84px;
            text-align:center;
        }
        .en{
            width:380px;
            height:112px;
            font-size:40px;
            font-family:Microsoft YaHei;
            font-weight:600;
            color:rgba(34,34,34,1);
            line-height:56px;
            margin: 0 auto;
        }
        div.bankuai{
            display: flex;
            flex-direction: row;
        }
       ul{
         margin-top: 40px;
         display: flex;
         flex-direction: row;
         flex-wrap: wrap;
         width: 600px;
         justify-content: space-between;
         /* align-items: center; */
          .active{
            background:linear-gradient(270deg,rgba(1,121,233,1) 0%,rgba(0,182,255,1) 100%);
            box-shadow:0px 4px 20px 0px rgba(0,151,255,0.5);
            color:#fff;
          }
          &:hover li{
            background:rgba(250,250,250,1);
            box-shadow: none;
            color: #000;
          }
         li{
          font-size:20px;
          color:rgba(34,34,34,1);
          text-align:center;
          line-height:70px;
          width:287px;
          height:70px;
          background:rgba(250,250,250,1);
          margin-bottom: 15px;
          &:hover{
            /* width:287px; */
            /* height:70px; */
            background:linear-gradient(270deg,rgba(1,121,233,1) 0%,rgba(0,182,255,1) 100%);
            box-shadow:0px 4px 20px 0px rgba(0,151,255,0.5);
            color:#fff;
            /* text-align:center; */
            /* line-height:70px; */
          }
         }
        
       }
      }
    }
    .tqDesc{
          width:100%;
          height:170px;
          background:rgba(251,251,251,1);
          .bannerW{
            height:100%;
            display:flex;
            flex-direction:row;
            align-items: center;

          }
          ul{
            width:100%;
            display:flex;
            flex-direction:row;
            justify-content:space-between;
            li{
              display:flex;
              flex-direction:row;
              align-items:flex-start;
          .imgDesc{
              width: 66px;
              height:66px;
          }
          .imgText{
            margin-left: 15px;
            .name{
              font-size:20px;
              font-family:Microsoft YaHei;
              font-weight:600;
              color:rgba(34,34,34,1);
            }
            .name2{
              width: 210px;
            }
            .desc{
              font-size:16px;
              font-family:Microsoft YaHei;
              font-weight:400;
              color:rgba(153,153,153,1);
              margin-top:15px;
            }
            .desc0{
              width: 200px;
            }
            .desc2{
              width: 223px;
            }
            .desc3{
              width: 146px;
            }
          }
        }
      }
    }
    
  </style>